// Swiper - Main Slider
var $sliderSwiper = $('.mainSliderSwiper');

if ($sliderSwiper.length) {
  var mainSlideCount = $sliderSwiper.find('.swiper-slide').length;
  var mainMaxSlidesPerView = 1;

  let sliderSwiper = new Swiper('.mainSliderSwiper', {
      direction: 'horizontal',
      touchRatio: 1,
      loop: mainSlideCount > mainMaxSlidesPerView * 2,
      effect: 'fade',
      observer: true,
      observeParents: true,

      fadeEffect: {
          crossFade: true
      },
      pagination: {
          el: '.swiper-pagination',
          clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
      },
      keyboard: {
          enabled: true,
          onlyInViewport: true,
      },
      a11y: {
          enabled: true,
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
      },
      on: {
        init: function () {
          if (this.isLocked) {
            $sliderSwiper.find('.swiper-button-next, .swiper-button-prev').hide();
          }
        }
      }
  });
}

// Products Swiper
var $productsSwiper = $('.productsSwiper');

if ($productsSwiper.length) {
  var productSlideCount = $productsSwiper.find('.swiper-slide').length;
  var productMaxSlidesPerView = 4;

  let productSwiper = new Swiper('.productsSwiper', {
    direction: 'horizontal',
    loop: productSlideCount > productMaxSlidesPerView * 2,
    slidesPerView: 2,
    spaceBetween: 15,
    observer: true,
    observeParents: true,

    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
    },

    breakpoints: {
        1024: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        1400: {
            slidesPerView: 4,
            spaceBetween: 20,
        }
    },
    on: {
      init: function () {
        if (this.isLocked) {
          $productsSwiper.find('.swiper-button-next, .swiper-button-prev').hide();
        }
      }
    }
  });
}

// Blog Swiper
var $blogSwiper = $('.blogSwiper');

if ($blogSwiper.length) {
  var blogSlideCount = $blogSwiper.find('.swiper-slide').length;
  var blogMaxSlidesPerView = 3;

  let blogSwiper = new Swiper('.blogSwiper', {
      direction: 'horizontal',
      loop: blogSlideCount > blogMaxSlidesPerView * 2,
      slidesPerView: 1,
      observer: true,
      observeParents: true,

      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
      a11y: {
          enabled: true,
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
      },

      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        1400: {
          slidesPerView: 3,
          spaceBetween: 10
        }
      },
      on: {
        init: function () {
          if (this.isLocked) {
            $blogSwiper.find('.swiper-button-next, .swiper-button-prev').hide();
          }
        }
      }
  });
}